import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as ItineraryFragment } from './itinerary';

export const SEM_SELECT_ITINERARY = gql`
  mutation semItinerarySelection(
    $semItinerarySelectionRequest: SemItinerarySelectionRequest!
  ) {
    semItinerarySelection(
      semItinerarySelectionRequest: $semItinerarySelectionRequest
    ) {
      searchId
      itineraries {
        ...Itinerary
      }
    }
  }
  ${ItineraryFragment}
`;
